import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getRequest } from "../../services/apiMethods";
import { truncateText } from "../../utils/HelperFunctions";
const Portfolio = () => {
  const Navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const {
    data: portfolioDetails,
    error: userError,
    isLoading: userLoading,
  } = useQuery({
    queryKey: ["PortfolioDetail"],
    queryFn: () => getRequest(`portfolio/list`),
  });

  return (
    <div className="my-profile-box-contain">
      <div className="my-profile-box-form">
        <div className="h-100 m-0">
          <div className="form-box-title ">
            <div>
              <h4>Portfolio</h4>
              <p>Showcase what your business can do</p>
            </div>
            <button
              className="theme-comm-btn"
              onClick={() => Navigate("/portfolio-detail")}
            >
              Add
            </button>
          </div>
          <div className="portfolio-card-contain">
            <Row>
              {Array.isArray(portfolioDetails?.data) &&
              portfolioDetails?.data?.length > 0 ? (
                portfolioDetails?.data?.map((res, index) => {
                  return (
                    <>
                      <Col
                        lg={6}
                        key={index}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          Navigate(`/portfolio-detail?id=${res?._id}`)
                        }
                      >
                        <div className="portfolio-card-box">
                          {res?.image?.length > 0 ? (
                            <img
                              src={
                                `${res?.image[0]}` ||
                                require("../../assets/images/dimmy-img.png")
                              }
                            />
                          ) : (
                            <img
                              src={require("../../assets/images/dimmy-img.png")}
                            />
                          )}
                          <h4>{res?.projectName || ""} </h4>
                          <p>
                            {res?.description
                              ? truncateText(res.description, 15)
                              : ""}
                          </p>
                        </div>
                      </Col>
                    </>
                  );
                })
              ) : (
                <>{/* <p>No Data Found</p> */}</>
              )}
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
